import React, { useEffect } from "react";
import Header from "./components/Header";
import About from "./components/About";
import Resume from "./components/Resume";
import Services from "./components/Services";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Blog from "./components/Blog";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ErrorBoundary from "./components/ErrorBoundary";
import SEO from "./components/SEO";

const App = () => {
  useEffect(() => {
    // Handle loading state
    document.body.classList.add('loading');

    const loadTimeout = setTimeout(() => {
      document.body.classList.remove('loading');
      document.body.classList.add('loaded');
    }, 1500);

    // Safe check for jQuery
    const initializeWaypoints = () => {
      if (typeof window.jQuery !== 'undefined' && window.jQuery.fn && window.jQuery.fn.waypoint) {
        try {
          window.jQuery('.animate-box').waypoint(function (direction) {
            if (direction === 'down' && !window.jQuery(this.element).hasClass('animated')) {
              window.jQuery(this.element).addClass('item-animate');
              setTimeout(function () {
                window.jQuery('body .animate-box.item-animate').each(function (k) {
                  const el = window.jQuery(this);
                  setTimeout(function () {
                    const effect = el.data('animate-effect');
                    if (effect === 'fadeIn') {
                      el.addClass('fadeIn animated');
                    } else if (effect === 'fadeInLeft') {
                      el.addClass('fadeInLeft animated');
                    } else if (effect === 'fadeInRight') {
                      el.addClass('fadeInRight animated');
                    } else {
                      el.addClass('fadeInUp animated');
                    }
                    el.removeClass('item-animate');
                  }, k * 200, 'easeInOutExpo');
                });
              }, 100);
            }
          }, { offset: '85%' });
        } catch (error) {
          console.log('Waypoint initialization error:', error);
        }
      }
    };

    // Initialize with a delay to ensure DOM is ready
    const waypointTimeout = setTimeout(initializeWaypoints, 1000);

    return () => {
      // Cleanup
      clearTimeout(loadTimeout);
      clearTimeout(waypointTimeout);
      document.body.classList.remove('loading');
      document.body.classList.remove('loaded');
    };
  }, []);

  return (
    <div id="page">
      <SEO />
      <ErrorBoundary>
        <Header />
      </ErrorBoundary>
      <ErrorBoundary>
        <About />
      </ErrorBoundary>
      <ErrorBoundary>
        <Resume />
      </ErrorBoundary>
      <ErrorBoundary>
        <Services />
      </ErrorBoundary>
      <ErrorBoundary>
        <Skills />
      </ErrorBoundary>
      <ErrorBoundary>
        <Projects />
      </ErrorBoundary>
      <ErrorBoundary>
        <Blog />
      </ErrorBoundary>
      <ErrorBoundary>
        <Contact />
      </ErrorBoundary>
      <ErrorBoundary>
        <Footer />
      </ErrorBoundary>
    </div>
  );
};

export default App;
